(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './Spinners'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Spinners'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Spinners);
    global.index = mod.exports;
  }
})(this, function (exports, _Spinners) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SpinnerLarge = exports.Spinner = undefined;
  exports.Spinner = _Spinners.Spinner;
  exports.SpinnerLarge = _Spinners.SpinnerLarge;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/LoadingIndicators/index.js
// module id = 530
// module chunks = 1